import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Hero from '../components/Hero';
import Skills from '../components/Skills';
import Education from '../components/Education';
import Projects from '../components/Projects';
import Works from '../components/Works';
import Contact from '../components/Contact';

const Home = ({ hasPlayableSong, isPlaying, togglePlayback, song, waveform }) => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      
      if (id.toLowerCase() === 'contact') {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      } else {
        const element = document.getElementById(id) || document.querySelector(`[id="${id}" i]`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div style={{ position: "relative" }}>
      {/* 
        Main layout content is wrapped to sit above the fixed footer.
        marginBottom: 100vh gives space to scroll all the way to the 
        bottom, pulling this elevated foreground layer UP, thereby revealing 
        the contact footer hiding underneath.
      */}
      <main style={{ position: "relative", zIndex: 2, background: "#000000", marginBottom: "100vh" }}>
        <Hero
          hasPlayableSong={hasPlayableSong}
          isPlaying={isPlaying}
          onTogglePlayback={togglePlayback}
          song={song}
          waveform={waveform}
        />
        <Skills />
        <Education />
        <Projects />
        <Works />
      </main>
      
      {/* Contact Reveal Container - Fixed to the Back */}
      <div 
        style={{ 
          position: "fixed", 
          bottom: 0, 
          left: 0,
          right: 0,
          height: "100vh", 
          zIndex: 1,
          overflow: "hidden"
        }}
      >
        <Contact />
      </div>
    </div>
  );
};

export default Home;
